import moment from 'moment-timezone';

import timezones from './timezones.json';

export interface Timezones {
    [key: string]: string;
}

export function getTimezones(): Timezones {
    const timezonesObject = {};

    timezones.forEach((item) => {
        timezonesObject[item.tzid] = `(${moment().tz(item.tzid).format('Z')}) ${item.country}`;
    });

    return timezonesObject;
}

export interface Timezone {
    tzid: string;
    country: string;
}
export function getCurrentTimezone(): Timezone {
    const tzid = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const country = timezones.find((item) => item.tzid === tzid)?.country;

    return {
        tzid,
        country: `(${moment().tz(tzid).format('Z')}) ${country}`,
    };
}
